import { forwardRef } from 'react';

import * as Styled from './Carousel.styles';

const CarouselViewport = forwardRef(({ className, ...props }, ref) => {
  return <Styled.Viewport ref={ref} className={className} {...props} />;
});

CarouselViewport.displayName = 'CarouselViewport';

export default CarouselViewport;
